define('modules/duplicate_control/collection',['require','exports','module','base/collection','./model','env','jquery'],function(require, exports, module){
  "use strict";

  var Collection = require("base/collection"),
    DuplicateControlModel = require("./model"),
    config = require("env"),
    $ = require("jquery");

  module.exports = Collection.extend({
    model: DuplicateControlModel,
    url: function(){
      return config.apiHost + "/duplicate-control";
    },
    fetchByPageIdAndType: function(pageId, type) {
      return this.fetch({data: $.param({pageId: pageId, type: type})});
    }
  });

});

